"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var ConfigSubsection_1 = tslib_1.__importDefault(require("../../configurationControls/ConfigSubsection"));
var LabelRotationControl_1 = tslib_1.__importDefault(require("./LabelRotationControl"));
var LabelFormatControl_1 = require("./LabelFormatControl");
var LabelSubsection = /** @class */ (function (_super) {
    tslib_1.__extends(LabelSubsection, _super);
    function LabelSubsection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LabelSubsection.prototype.render = function () {
        var _a = this.getControlProperties(), axisVisible = _a.axisVisible, axisLabelsEnabled = _a.axisLabelsEnabled;
        return (react_1.default.createElement(ConfigSubsection_1.default, { title: "properties.axis.labels", valuePath: this.props.axis + ".labelsEnabled", properties: this.props.properties, pushData: this.props.pushData, canBeToggled: true, toggledOn: axisLabelsEnabled, toggleDisabled: this.props.disabled || !axisVisible, showDisabledMessage: !this.props.configPanelDisabled && this.props.disabled },
            this.props.showFormat && (react_1.default.createElement(LabelFormatControl_1.LabelFormatControl, { disabled: this.props.disabled, configPanelDisabled: this.props.configPanelDisabled, axis: this.props.axis, properties: this.props.properties, pushData: this.props.pushData })),
            react_1.default.createElement(LabelRotationControl_1.default, { disabled: this.props.disabled, configPanelDisabled: this.props.configPanelDisabled, axis: this.props.axis, properties: this.props.properties, pushData: this.props.pushData })));
    };
    LabelSubsection.prototype.getControlProperties = function () {
        var _a, _b, _c, _d;
        var axisProperties = (_b = (_a = this.props.properties) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b[this.props.axis];
        var axisVisible = (_c = axisProperties === null || axisProperties === void 0 ? void 0 : axisProperties.visible) !== null && _c !== void 0 ? _c : true;
        var axisLabelsEnabled = (_d = axisProperties === null || axisProperties === void 0 ? void 0 : axisProperties.labelsEnabled) !== null && _d !== void 0 ? _d : true;
        return {
            axisVisible: axisVisible,
            axisLabelsEnabled: axisLabelsEnabled,
        };
    };
    return LabelSubsection;
}(react_1.default.PureComponent));
exports.default = react_intl_1.injectIntl(LabelSubsection);
//# sourceMappingURL=LabelSubsection.js.map